import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTracker } from '../../contexts/TrackerContext';

const PostSurveyIntro: React.FC = () => {
  const navigate = useNavigate();
  const { tracker } = useTracker();

  const handleStartSurvey = () => {
    tracker.track('postSurveyIntroStart', {
      phase: 'post-survey-intro'
    });
    navigate('/post-survey');
  };

  return (
    <div style={{
      maxWidth: '800px',
      margin: '0 auto',
      padding: '40px 20px',
      textAlign: 'center',
      fontFamily: 'system-ui, -apple-system, sans-serif'
    }}>
      <div style={{
        backgroundColor: '#f8f9fa',
        padding: '40px',
        borderRadius: '12px',
        border: '2px solid #e9ecef'
      }}>
        <div style={{
          fontSize: '48px',
          marginBottom: '20px'
        }}>✅</div>
        
        <h1 style={{
          color: '#2c3e50',
          marginBottom: '20px'
        }}>
          Great Work!
        </h1>
        
        <p style={{
          fontSize: '18px',
          color: '#495057',
          marginBottom: '30px',
          lineHeight: '1.6'
        }}>
          You have successfully completed the main security evaluation tasks.
        </p>
        
        <div style={{
          backgroundColor: 'white',
          padding: '30px',
          borderRadius: '8px',
          marginBottom: '30px',
          textAlign: 'left'
        }}>
          <h3 style={{
            color: '#2c3e50',
            marginBottom: '15px',
            textAlign: 'center'
          }}>
            One Final Step
          </h3>
          
          <p style={{
            color: '#6c757d',
            marginBottom: '15px',
            textAlign: 'center'
          }}>
            To complete this study, we would like to collect some additional information 
            through a brief questionnaire. This will help us better understand the 
            decision-making process and improve future research.
          </p>
          
          <ul style={{
            color: '#495057',
            paddingLeft: '20px',
            lineHeight: '1.6'
          }}>
            <li>Basic demographic information</li>
            <li>Your experience with the tasks</li>
            <li>Brief questions about your background</li>
          </ul>
          
          <p style={{
            color: '#6c757d',
            marginTop: '20px',
            fontSize: '16px',
            textAlign: 'center'
          }}>
            <strong>Estimated time:</strong> 5-7 minutes
          </p>
        </div>
        
        <button
          onClick={handleStartSurvey}
          style={{
            backgroundColor: '#0066cc',
            color: 'white',
            border: 'none',
            padding: '15px 30px',
            fontSize: '18px',
            fontWeight: '600',
            borderRadius: '8px',
            cursor: 'pointer',
            boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
            transition: 'background-color 0.2s ease'
          }}
          onMouseOver={(e) => e.currentTarget.style.backgroundColor = '#0056b3'}
          onMouseOut={(e) => e.currentTarget.style.backgroundColor = '#0066cc'}
        >
          Continue to Questionnaire
        </button>
        
        <p style={{
          fontSize: '14px',
          color: '#868e96',
          marginTop: '20px'
        }}>
          Your responses will be kept confidential and associated with a study
          participant identifier as described in the consent form.
        </p>
      </div>
    </div>
  );
};

export default PostSurveyIntro;
